// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__2mQdu","navText":"Navbar_navText__1PGlZ","navLogo":"Navbar_navLogo__3s0iK","imgLogo":"Navbar_imgLogo__2j1zW"};